module.exports = __webpack_public_path__ + "img/wushuibg.50ababd7.50ababd7.png";